/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Úroveň důležitosti chyby.
 * Vychází z úrovní zavedených v Console API pod pojmenováním `logLevel`.
 * Úrovně mají následující prioritu:
 * `Error` > `Warning` > `Info` > `Log` > `Debug`.
 *
 * Zdroje:
 * - [Console API](https://console.spec.whatwg.org/)
 * @enum {string}
 */
const ErrorLevel = {
  /** Verbose debug log which is usually hidden by default. */
  Debug: 'Debug',
  /** Critical error which can lead to an unexpected bahaviour or a crash. */
  Error: 'Error',
  /** Informative log with a slightly higher than low significance. */
  Info: 'Info',
  /** Common log with a low significance. */
  Log: 'Log',
  /** Warning about an unusual state which won't affect the script execution. */
  Warning: 'Warning'
};

export default ErrorLevel;
